if (!customElements.get('hh-brand-details-wrapper')) {
  class HHBrandDetailsWrapper extends HTMLElement {
    constructor() {
      super()

      this.selectors = {
        section: '.shopify-section',
        media: '[data-media-block-id]',
        mediaByBlockId: (blockId) => `[data-media-block-id="${blockId}"]`,
        disclosures: 'hh-details-disclosure',
        video: 'hh-inline-video',
      }

      this.section = this.closest(this.selectors.section)
      this.disclosures = this.querySelectorAll(this.selectors.disclosures)
      this.media = this.section.querySelectorAll(this.selectors.media)
      this.videos = this.section.querySelectorAll(this.selectors.video)
      this.activeBlock = null

      this.classes = {
        hide: 'hidden',
      }

      this.handleResize()
    }

    connectedCallback() {
      this.disclosures.forEach((disclosure) => {
        disclosure.addEventListener('click', this.onDisclosureClick.bind(this))
      })
      window.addEventListener('resize', this.handleResize.bind(this))
    }

    disconnectedCallback() {
      this.disclosures.forEach((disclosure) => {
        disclosure.removeEventListener('click', this.onDisclosureClick)
      })
      window.addEventListener('resize', this.handleResize.bind(this))
    }

    handleResize() {
      this.isMobile = window.matchMedia('(max-width: 749px)').matches
      this.stopAllVideos()
    }

    onDisclosureClick(e) {
      const { currentTarget } = e
      if (this.activeBlock === currentTarget.dataset.blockId) {
        this.checkIfAllDisclosuresAreClosed()
        return
      }

      this.stopAllVideos()
      this.closeOtherDisclosures(currentTarget)
      this.toggleActiveMedia(currentTarget)
      this.playMobileVideo(currentTarget)
    }

    closeOtherDisclosures(currentTarget) {
      this.disclosures.forEach((disclosure) => {
        if (disclosure !== currentTarget && disclosure.open) {
          disclosure.toggle()
        }
      })
    }

    toggleActiveMedia(currentTarget) {
      if (this.isMobile) return

      const { blockId } = currentTarget.dataset
      const blockMedia = this.section.querySelector(
        this.selectors.mediaByBlockId(blockId)
      )

      this.media.forEach((item) => {
        const video = item.querySelector(this.selectors.video)

        if (item !== blockMedia) {
          item.classList.add(this.classes.hide)
        } else {
          this.activeBlock = item.dataset.mediaBlockId
          item.classList.remove(this.classes.hide)
          video?.play()
        }
      })

      if (blockMedia === null) {
        this.media[0].classList.remove(this.classes.hide)
        return
      }
    }

    playMobileVideo(currentTarget) {
      this.activeBlock = currentTarget.dataset.blockId
      if (!this.isMobile) return
      const video = currentTarget.querySelector(this.selectors.video)
      if (video?.playing === false) video.play()
    }

    stopAllVideos() {
      if (this.videos.length === 0) return
      this.videos.forEach(
        (video) => typeof video.stop == 'function' && video.stop()
      )
    }

    checkIfAllDisclosuresAreClosed() {
      const openedDisclosures = this.querySelectorAll('[is-open]')

      if (openedDisclosures.length === 0) {
        this.media.forEach((item) => item.classList.add(this.classes.hide))
        this.media[0].classList.remove(this.classes.hide)
        this.stopAllVideos()
      }
    }
  }
  customElements.define('hh-brand-details-wrapper', HHBrandDetailsWrapper)
}
